import { useCallback, useEffect, useReducer, useState } from "react";
import { getInvoiceFormOptions } from "API/swesum";
import dayjs from "dayjs";
import { useAuth } from "Hooks/useAuth";

const initialFormState = {
  ClientId: null,
  ClientCreditFee: "",
  ClientServiceFee: "",
  ClientDirectPayment: "",
  CreateTime: "",
  CurrencyCode: "SEK",
  EndCustomerId: null,
  DueDate: null,
  ExternalInvoiceNo: "",
  ExternalReference: "",
  FileId: "",
  InvoiceId: "",
  InvoiceDate: dayjs(new Date()).format("YYYY-MM-DD"),
  OriginalDeadlineDate: "",
  OriginalFfdDate: "",
  Pm1WaitCreateDate: "",
  OurReference: "",
  ParseMessage: "",
  ParseStatus: "",
  Pm1Fee: "",
  Pm1FfdDate: "",
  Pm2WaitCreateDate: null,
  Pm2Fee: "",
  CollectionWaitCreateDate: "",
  Pm2FfdDate: "",
  Price: 0,
  Regress: -1,
  Service: "purchase",
  SystemStatus: "",
  Text: "",
  OCR: null,
  EndCustomerNumber: "",
};

const formDataReducer = (state, action) => {
  switch (action.type) {
    case "ON_CHANGE":
      return { ...state, [action.field]: action.newVal };
    case "RESET_FORM":
      return action.initialFormData;
    default:
      return state;
  }
};

export default function useInvoiceFormOptions(clientId) {
  const { isAdmin } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState({
    clients: [],
    endcustomers: [],
    currencyCodes: [],
    services: [],
    boolOptions: [],
    files: [],
  });

  const [formData, dispatchFormData] = useReducer(
    formDataReducer,
    initialFormState
  );

  const handleInputChange = useCallback((field, newVal) => {
    dispatchFormData({ type: "ON_CHANGE", field: field, newVal: newVal });
  }, []);

  //Fetching all neccencary options to create an invoice.
  useEffect(() => {
    (async function () {
      try {
        if (!isAdmin) return;
        setLoading(true);
        const response = await getInvoiceFormOptions(clientId);
        const [endcustomers, currencyCodes, services, boolOptions] = response;
        setOptions({
          endcustomers: endcustomers,
          currencyCodes: currencyCodes,
          services: services,
          boolOptions: boolOptions,
        });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return {
    options,
    error,
    loading,
    formData,
    handleInputChange,
  };
}
